import { Column } from "@/components/Datatable/types";
import { MyVoucherItem } from "../../api/fetchMyVouchers/types";

/**
 * The admin vouchers report columns minus Company and Intacct ID. Sortable
 * columns use the backend sort key as their accessorKey.
 */
export function myVouchersColumns(): Column<MyVoucherItem>[] {
  return [
    {
      header: "Voucher Code",
      accessorKey: "voucherCode",
      enableSorting: true,
      cell: ({ row }) => row.original.voucherCode,
    },
    {
      header: "Date Issued",
      accessorKey: "dateIssued",
      enableSorting: true,
      cell: ({ row }) => row.original.dateIssued ?? "",
    },
    {
      header: "Expiration Date",
      accessorKey: "expirationDate",
      enableSorting: true,
      cell: ({ row }) => row.original.expirationDate ?? "",
    },
    {
      header: "Total Seats",
      accessorKey: "totalSeats",
      enableSorting: true,
      cell: ({ row }) => row.original.totalSeats,
    },
    {
      header: "Open",
      accessorKey: "openCount",
      cell: ({ row }) => row.original.openCount,
    },
    {
      header: "Applied",
      accessorKey: "appliedCount",
      cell: ({ row }) => row.original.appliedCount,
    },
    {
      header: "Redeemed",
      accessorKey: "redeemedCount",
      cell: ({ row }) => row.original.redeemedCount,
    },
    {
      header: "Forfeited",
      accessorKey: "forfeitedCount",
      cell: ({ row }) => row.original.forfeitedCount,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => row.original.status,
    },
  ];
}
